import Dexie, { type Table } from 'dexie';

export type DexieInstance = Dexie & {
  kuraemon_cloud2_job: Table
  kuraemon_cloud2_account: Table
  kuraemon_cloud2_photo: Table
  kuraemon_cloud2_kokuban: Table
  kuraemon_cloud2_latest_modified_at: Table
  kuraemon_cloud2_search_result: Table
  kuraemon_cloud2_zumen: Table
  kuraemon_cloud2_construction_empty_folder_name_parts_list: Table
  kuraemon_cloud2_zumen_entity: Table
  kuraemon_cloud2_zumen_page: Table
}

export const DexieConfig: {
  version: number
  database: string
  schemas:  Array<{[tableName: string]: string}>
  } = {
  // Dexie向けの設定
  version: 14,
  database: 'kuraemonCloud',
  schemas: [
    {
      // バックグラウンドジョブテーブル
      kuraemon_cloud2_job: [
        'job_id', // primary key
      ].join(','),
    },
    {
      // アカウントテーブル
      kuraemon_cloud2_account: [
        'account_id', // primary key
      ].join(','),
    },
    {
      // 写真テーブル
      kuraemon_cloud2_photo: [
        '[cloud_construction_id+photo_key]', // primary key
        'cloud_construction_id',
        'hidden_at',
        'deleted_at',
        '*search_word_kokubans',
        '[cloud_construction_id+hidden_at]',
        '[cloud_construction_id+hidden_at+deleted_at]',
      ].join(','),
    },
    {
      // 黒板テーブル
      kuraemon_cloud2_kokuban: [
        '[cloud_construction_id+kokuban_hash]', // primary key
        'cloud_construction_id',
        'kokuban_hash',
        'hidden_at',
        'deleted_at',
        '*search_word_kokubans',
        '[cloud_construction_id+hidden_at]',
        '[cloud_construction_id+hidden_at+deleted_at]',
      ].join(','),
    },
    {
      // 最終更新時刻
      kuraemon_cloud2_latest_modified_at: [
        '[cloud_construction_id+item_type]', // primary key
      ].join(','),
    },
    {
      // 検索結果キャッシュ
      kuraemon_cloud2_search_result: [
        '[cloud_construction_id+item_type+latest_modified_at+search_word]', // primary key
      ].join(','),
    },
    {
      // 図面テーブル
      kuraemon_cloud2_zumen: [
        '[cloud_construction_id+zumen_id]', // primary key
        'cloud_construction_id',
        'zumen_id',
        'zumen_status',
        '[cloud_construction_id+zumen_status]',
      ].join(','),
    },
    {
      // 図面フォルダ内の空のフォルダ名のリスト
      kuraemon_cloud2_construction_empty_folder_name_parts_list: [
        'cloud_construction_id', // primary key
      ].join(','),
    },
    {
      // 図面エンティティ
      kuraemon_cloud2_zumen_entity: [
        '[cloud_construction_id+zumen_id+zumen_entity_code]', // primary key
        'cloud_construction_id',
        'zumen_id',
        'zumen_entity_code',
        '[cloud_construction_id+zumen_id]',
      ].join(','),
    },
    {
      // 図面ページ
      kuraemon_cloud2_zumen_page: [
        '[cloud_construction_id+zumen_id+page_no]', // primary key
        'cloud_construction_id',
        'zumen_id',
        'page_no',
        '[cloud_construction_id+zumen_id]',
      ].join(','),
    },
  ],
}

export const initDexie = async (config = DexieConfig) => {
  const db = new Dexie(config.database) as  Dexie & {
    kuraemon_cloud2_latest_modified_at: any
  };
  const schemas = config.schemas
  const version = config.version ? config.version : 1
  for(const schema of schemas){
    db.version(version).stores(schema) // Create DB schema
  }

  if(!db.isOpen()){ // DB not open, opening...
    try{
      await db.open()
    }catch(error){
      console.warn('A IndexedDB error occured', error)
      throw error
    }
  }
  db.backendDB().onclose = event => {
    console.error(event);
    if(window && window.location) window.location.reload();
  };
  return db;
}
